import Box from '@mui/material/Box'
import React from 'react'
import Typography from '@mui/material/Typography'

export default function HeaderProm({ show }) {
    return (
        show &&
        (
            <Box backgroundColor={'#21333B'} color={'#fff'} textAlign={'center'} height={{md: '30px', xs: 'auto'}} paddingY={{ md: 'unset', xs: '10px' }} justifyContent={'center'} display={'flex'} alignItems={'center'}>
                <Typography variant="body1" component={'p'} fontSize={'0.875rem'}>Never Miss A Day - Subscribe And Get 20% Off From Every Product</Typography>
            </Box>
        )
    )
}